const ComingSoonBanner = () => {
  return (
    <div
      style={{
        background: "#FFFBEA",
        borderBottom: "1px solid #E9C46A",
        padding: "0.65rem 1rem"
      }}
      data-testid="coming-soon-banner"
    >
      <p style={{
        margin: 0,
        color: "#7C5A00",
        fontSize: "0.85rem",
        fontFamily: "Manrope, sans-serif",
        fontWeight: "500",
        lineHeight: "1.4"
      }}>
        Post your event for free {" "}
        <a
          href="/host/submit"
          style={{
            color: "#7C5A00",
            textDecoration: "underline",
            fontWeight: "600"
          }}
        >
          Submit your event &rarr;
        </a>
      </p>
    </div>
  );
};

export default ComingSoonBanner;
